<script setup lang="ts">
import { Notification, Notivue } from 'notivue'
import { useUiStore } from '@/stores/ui'
import AppBootUpSplashScreen from '@/shared/components/ui/app/AppBootUpSplashScreen.vue'
import { useUi } from '@/composables/useUi'

const { uiActions } = useUi()
const { storeActionIsInProgress } = useUiStore()
</script>

<template>
  <RouterView v-slot="{ Component }">
    <transition>
      <component :is="Component" />
    </transition>
  </RouterView>

  <Notivue v-slot="item">
    <Notification :item="item" />
  </Notivue>

  <!-- Loading splash screen while middleware is running -->
  <Transition>
    <div
      v-if="storeActionIsInProgress(uiActions.bootingApp)"
      class="absolute inset-0 z-[99999] flex items-center justify-center bg-gray-50"
    >
      <AppBootUpSplashScreen />
    </div>
  </Transition>
</template>

<style scoped>
.v-enter-active,
.v-leave-active {
  transition: opacity 0.3s ease;
}
.v-leave-to {
  opacity: 0;
}
</style>
